import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import CodedValueContent from './CodedValueContent';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';

const form = {
  keyword: '',
};

function CodedValueContainer({
  match,
  history,
  getCodedValueList,
  codedValueList,
  isLoading,
  removeCodedValue,
  codedValueListPager,
  getSingleCodedValue,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Coded Value',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Coded Value',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this Coded Value?',
      () => {
        removeCodedValue(data.id, () => {
          getCodedValueList();
          const id = _.get(codedValueList, '0.id');
          history.push(`${id}`);
          getSingleCodedValue(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getCodedValueList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getCodedValueList({ q: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:codedValueId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Coded Value"
            getData={getCodedValueList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:codedValueId?`}
            listName="Coded Values"
            label="Coded Values"
            renderItem={(item) => (
              <div className="p-3">{_.get(item, 'attributes.name')}</div>
            )}
            isLoading={isLoading}
            selected={params.codedValueId}
            data={codedValueList}
            dataPager={codedValueListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:codedValueId?`}
                    render={() => (
                      <CodedValueContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:codedValueId?`}
                  render={() =>
                    !params.codedValueId && codedValueList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(codedValueList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

CodedValueContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getCodedValueList: PropTypes.instanceOf(Function).isRequired,
  codedValueList: PropTypes.instanceOf(Array).isRequired,
  codedValueListPager: PropTypes.instanceOf(Object).isRequired,
  removeCodedValue: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getSingleCodedValue: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  codedValueList: _.get(api, `${c.GET_CODED_VALUE_LIST}.list`) || [],
  codedValueListPager: _.get(api, `${c.GET_CODED_VALUE_LIST}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_CODED_VALUE_LIST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(CodedValueContainer);
